
import { defineComponent } from "vue";
import { LanguageSwitcher } from "@/common/components";
import NotificationList from "./modules/ui/components/NotificationList.vue";
import TheNavigation from "@/common/components/TheNavigation.vue";
import { mapState } from "vuex";
import { UIState } from "./modules/ui/store/types";

export default defineComponent({
  name: "App",

  data() {
    return {
      showMenu: false,
    };
  },
  computed: {
    ...mapState("ui", {
      isNavOpen: (state) => (state as UIState).isNavOpen,
    }),
  },
  watch: {
    isNavOpen(val) {
      document.body.style.overflow = val ? "hidden" : "";
    },
  },
  components: {
    LanguageSwitcher,
    NotificationList,
    TheNavigation,
  },
});
